import { v2Client } from '@api/apiClient'
import { ConversationType } from '@components/chat/types'
import { Pagination } from '@components/utils/pagination'
import { useInfiniteQuery } from '@tanstack/react-query'

export const conversationsKeys = {
  getAll: ['conversations', 'list'],
}

export type GetConversationResponse = {
  active_index_id: number
  chats: ConversationType[]
  pagination: Pagination
}

export const useGetConversations = () => {
  return useInfiniteQuery({
    queryKey: conversationsKeys.getAll,
    queryFn: ({ pageParam = 1 }) =>
      v2Client.get(`conversations`).then(
        (res): GetConversationResponse => ({
          chats: res.data.data.map((item) => ({
            chat_id: item.id,
            created_at: new Date(item.created_at * 1000).toISOString(),
            first_user_query: item.name,
          })),
          active_index_id: 1,
          pagination: {
            current_page: 1,
            total_pages: 1,
            total_records: res.data.data.length,
            next_page: null,
            prev_page: null,
          },
        })
      ),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => lastPage.pagination?.next_page,
    getPreviousPageParam: (firstPage) => firstPage?.pagination?.prev_page,
    select: (data) =>
      data?.pages?.reduce((previousValue, currentValue) => {
        return previousValue.concat(currentValue.chats)
      }, [] as ConversationType[]),
  })
}
